import { Typography } from "@mui/material"

export function AuthoringAmendsAuditTitle({ group, children }) {
    const content = Array.isArray(group.content) ? group.content : []
    const entry = content.find((item) => item?.payload?.reviewCycle != null)
    const reviewCycle = entry?.payload?.reviewCycle ?? null

    if (!reviewCycle) return children

    return <Typography variant="subtitle1">Review Cycle {reviewCycle}</Typography>
}
